/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Two_Fa_Afterwards_PromptInputs */

const en_two_fa_afterwards_prompt = /** @type {(inputs: Two_Fa_Afterwards_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Afterwards, enter the code in the field below and press`)
};

const nl_two_fa_afterwards_prompt = /** @type {(inputs: Two_Fa_Afterwards_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vervolgens voer je de code in het onderstaande veld in en druk je op`)
};

/**
* | output |
* | --- |
* | "Afterwards, enter the code in the field below and press" |
*
* @param {Two_Fa_Afterwards_PromptInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const two_fa_afterwards_prompt = /** @type {((inputs?: Two_Fa_Afterwards_PromptInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Two_Fa_Afterwards_PromptInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_two_fa_afterwards_prompt(inputs)
	return en_two_fa_afterwards_prompt(inputs)
});